<template>

	<el-container style="width: 100%" v-if="this.$route.meta.hiddenSiderbar !== true">
	

		<el-container>
			<!-- <el-aside style="margin: 0px;padding: 0px;border: none;background: #747474;" class="sidebar"
				width="200px" v-if="!(path === '/')">
				<menuComponents></menuComponents>
			</el-aside> -->
			<el-aside style="background-color: #747474;margin: 0px;padding: 0px;border: none" class="sidebar"
				:width="isCollapse?'60px':'201px'" v-if="!(path === '/')">
				<div class="toggle-button" style="position: relative;height: 50px;">
					<div style="position: absolute;top: 0;right:0;width: 100%;height: 100%;
			display: flex;align-items: center;justify-content: flex-end;">
						<!-- <img v-if="isCollapse" @click="toggleCollapse" src="../src/assets/images/zhankai.png" alt=""
							style="width: 30px;height: 30px; display : block;">
						<img v-else @click="toggleCollapse" src="../src/assets/images/shousuo.png" alt=""
							style="width: 30px;height: 30px; display : block ;"> -->
						<div v-if="isCollapse" @click="toggleCollapse" style="width: 30px;height: 30px; display : block;color:#fff;">
							<i class="el-icon-s-unfold" style="font-size: 30px;"></i>
						</div>
						<div v-else @click="toggleCollapse" style="width: 30px;height: 30px; display : block;color:#fff;">
							<i class="el-icon-s-fold" style="font-size: 30px;"></i>
						</div>
					</div>
				</div>
				<menuComponents :isCollapse="isCollapse"></menuComponents>
				
			</el-aside>
			
			<el-main style="padding: 0px !important;margin:0 !important;">
				<el-header v-if="!(path === '/')" style="height:60px;color: black;border: none;">
					<heads></heads>
				</el-header>
				<div style="position: relative;">
					<el-tabs v-model="activeIndex" type="card" closable  @tab-remove="removeTab" @tab-click="clickTab">
						<el-tab-pane v-for="(item, index) in openTab" :key="item.fname" :label="item.fname"
							:name="item.routePath" >
						</el-tab-pane>
						
					</el-tabs>
					<el-button
					 v-if="$store.state.openTab.length>0" @click="clear" style="position: absolute;top: 0px;right: 10px;z-index: 1000;color: red;">清除</el-button>
				</div>
				<transition name="fade" mode="out-in">
					<keep-alive>
						<router-view v-if="$route.meta.keepAlive" style="width: 98.5%; margin: auto"></router-view>
					</keep-alive>
				</transition>
				<router-view v-if="!$route.meta.keepAlive" style="width: 98.5%; margin: auto"></router-view>
				<!-- <router-view style="width: 100%;margin: auto">

				</router-view> -->
				<!-- <router-view v-else></router-view> -->
			</el-main>
		</el-container>
		
	</el-container>
	<router-view style="width: 98.5%%;margin: auto;" v-else>
	
	</router-view>

	<!-- <el-container>
    <el-aside class="sidebar" v-if="!(path === '/')">
      <menuComponents v-if="!(path === '/')"></menuComponents>
    </el-aside>
    <heads v-if="!(path === '/')"></heads>
    <el-main>
      <router-view></router-view>
    </el-main> -->

	<!-- <el-container>
      
    </el-container> -->
	<!-- </el-container> -->
	<!-- <div id="app" style="height:100%">
    <heads v-if="!(path === '/')"></heads>
    <div style="display:flex;height:95%">
      <menuComponents v-if="!(path === '/')"></menuComponents>
      <router-view></router-view>
    </div>
  </div> -->
</template>

<script>
	import menuComponents from "./components/menuComponents"
	import heads from "./components/heads"
	
	export default {
		
		name: "app",
		data() {
			return {
				path: '',
				 isCollapse: false,
			
				tabIndex: 2,
				
			};
		},
		computed: {
			openTab() {
				return this.$store.state.openTab
			},
			activeIndex: {
				get() {
					return this.$store.state.activeIndex
				},
				set(val) {
				return	this.$store.commit('setactiveindex', val)
				}
			}
		},

		watch: {
			'$route'(to, from) {
				let flag = false
				for (let item of this.openTab) {
					if (item.name === to.name) {
						this.$store.commit('setactiveindex', to.path)
						flag = true
						break
					}
				}

				if (!flag) {
					this.$store.commit('addtabs', {
						route: to.path,
						name: to.name
					})
					this.$store.commit('setactive_index', to.path)
				}

			}
		},


		components: {
			menuComponents,
			heads
		},

		methods: {
			toggleCollapse() {
				this.isCollapse = !this.isCollapse
			},
			clear(){
				this.$store.state.openTab=[]
			},
			removeTab(target) {
				// console.log('22333-',target)
				// if (target == '/' || target == '/home') {
				// 	return
				// }
				this.$store.commit('deletetabs', target)
				
				if (this.activeIndex === target) {
					// 设置当前激活的路由
					if (this.openTab && this.openTab.length >= 1) {
						// console.log('=============', this.openTab[this.openTab.length - 1].routePath)
						this.$store.commit('setactiveindex', this.openTab[this.openTab.length - 1].routePath)
						// console.log(this.activeIndex)
						this.$router.push({
							path: this.activeIndex
						})
					}
				}else{
					// console.log(this.activeIndex)
				}
			},
			clickTab(tab) {
				// console.log(this.activeIndex);
				this.$router.push({
					path: this.activeIndex
				})
			
			}




		},
		mounted() {
			this.path = this.$route.path
			
		},
		
		watch: {
			$route(to, from) { //路由变化
				this.path = to.path
			}
		},
		created() {
			if(sessionStorage.getItem('token')){
				
			}else{
				this.$store.state.openTab=[]
			}

		
		}

	}
</script>
<style scoped lang="less">
	@import '~@/assets/css/common.less';
	
	.nav-icon {
		width: 24px;
		height: 22px;
		margin-right: 10px;
		box-sizing: border-box;
	}
	
	.el-container {
		background: @lowBg_color;
	}

	.sidebar {
		width: 150px;
		background: @menuBg_color;
		border-right: 2px solid #f2f3f8;
		font-size: 22px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: rgba(99, 104, 115, 1);
		transition: width 0.5s ease;

		.logo {
			margin: 0;
			font-size: 18px;
			height: 60px;
			text-align: center;
			border-bottom: 2px solid #f2f3f8;
			overflow: hidden;
			box-sizing: border-box;

			&-name {
				line-height: 60px;
				text-align: center;
			}
		}
	}

	.el-container {
		height: 100%;
	}

	.el-menu {
		border: none;
		background: transparent;
	}

	.el-header {
		background-color: #fff;
		display: flex;
		align-items: center;
		border-bottom: 2px solid #f2f3f8;

		.icon {
			font-size: 25px;
		}

		justify-content: space-between;

		.userInfo {
			display: flex;
			align-items: center;
			cursor: pointer;
			color: #333;

			.el-image {
				margin-right: 10px;
			}

			span {
				font-weight: bold;
			}

			.page_title {
				font-size: 20px;
				font-weight: bold;
				color: black;
				height: 20px;
				border-left: 2px solid black;
				display: flex;
				align-items: center;
				margin-left: 15px;
				padding-left: 15px;
			}
		}

		.hover {
			height: 40px;
		}

		.hover:hover {
			border-bottom: 3px solid #ccc;
		}
	}

	/deep/.el-submenu__title {
		padding-left: 37px !important;
		padding-right: 37px !important;
		display: flex;
		align-items: center;

		i {
			right: 37px;
			color: #fff;
		}
	}

	/deep/.el-menu--inline {
		text-align: center !important;
		background: rgba(241, 248, 255, 1);
	}

	.infoDrawer {
		width: 100%;
		padding: 0 20px;
	}

	.infoDrawer .userInfo {
		display: flex;
		align-items: center;
		font-weight: bold;
	}

	.el-drawer.rtl {
		width: 20% !important;
	}

	.el-button--danger {
		background: #f56c6c;
	}

	.container_page {
		padding: 15px;
		box-sizing: border-box;
		overflow: auto;
		min-width: 1000px;
	}

	.container_page .container {
		background: white;
		padding: 15px;
		border-radius: 15px;
	}
	/deep/.el-tabs{
		width: 95%;
	}

</style>


<!-- <style>
  body {
    margin: 0px;
    padding: 0px;
  }
</style> -->
